// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZTm0","label":"styles_label__24QjW"};